export default {
    data() {
        return {
            windowWidth: window.innerWidth,
        };
    },
    computed: {
        breakpoint() {
            if (this.windowWidth < 576) return 'xs';
            if (this.windowWidth < 768) return 'sm';
            if (this.windowWidth < 992) return 'md';
            if (this.windowWidth < 1200) return 'lg';
            return 'xl';
        },
        isSmallScreen() {
            return ['xs', 'sm', 'md'].includes(this.breakpoint);
        },
    },
    methods: {
        updateWindowWidth() {
            this.windowWidth = window.innerWidth;
        },
    },
    mounted() {
        window.addEventListener('resize', this.updateWindowWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowWidth);
    },
};
